import { useEffect, useState } from "react";
import { MOBILE_VIEWPORT_MAX } from "@/mobile/viewportPaths";

const QUERY = `(max-width: ${MOBILE_VIEWPORT_MAX}px)`;

function readIsMobileViewport(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia(QUERY).matches;
}

/**
 * true quando a viewport é estreita (celular / device toolbar).
 * Reage a resize e rotação.
 */
export function useIsMobileViewport(): boolean {
  const [isMobile, setIsMobile] = useState(readIsMobileViewport);

  useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const onChange = () => setIsMobile(mql.matches);

    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
